var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "osResContent txtC padTX" }, [
    (_vm.layers.abc == "") | _vm.isLogin
      ? _c("div", { staticClass: "cc-btn" }, [
          _c(
            "button",
            {
              staticClass: "osResBtn01L",
              staticStyle: { "max-width": "337px", width: "96%" },
              style: _vm.joinButtonColor,
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.$emit("reserve")
                }
              }
            },
            [_vm._v("예약 하기")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    (_vm.layers.abc != "") | _vm.isLogin
      ? _c("div", { staticClass: "cc-btn" }, [
          _c(
            "button",
            {
              staticClass: "osResBtn01L",
              class: { marTML: _vm.isLogin },
              staticStyle: { "max-width": "337px", width: "96%" },
              style: _vm.joinButtonColor,
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.$emit("cancel")
                }
              }
            },
            [_vm._v("예약 취소")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    (_vm.layers.abc != "") | _vm.isLogin
      ? _c("div", { staticClass: "cc-btn" }, [
          _c(
            "button",
            {
              staticClass: "osResBtn01L marTML",
              staticStyle: { "max-width": "337px", width: "96%" },
              style: _vm.joinButtonColor,
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.$emit("check")
                }
              }
            },
            [_vm._v("예약 확인")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8df2b5a6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8df2b5a6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/artistry/makeover/components/join.vue
// module id = null
// module chunks = 